import { render, staticRenderFns } from "./GoalStatusDetailModal.vue?vue&type=template&id=75ca5e4a&"
import script from "./GoalStatusDetailModal.vue?vue&type=script&lang=js&"
export * from "./GoalStatusDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./GoalStatusDetailModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports